import { render, staticRenderFns } from "./ImageHotspot.vue?vue&type=template&id=5cb1a0a2&scoped=true&"
import script from "./ImageHotspot.vue?vue&type=script&lang=js&"
export * from "./ImageHotspot.vue?vue&type=script&lang=js&"
import style0 from "./ImageHotspot.vue?vue&type=style&index=0&id=5cb1a0a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb1a0a2",
  null
  
)

export default component.exports